import { initEditTimeSection } from './edit_form_time_section';
import { initEditFormActions } from './edit_form_actions';
import { initEditFormSubmit } from './edit_form_submit';

/**
 * Callbacks: toggleTopMode(popup, mode), refreshDashboardShowing(uid, id),
 * refreshLucideIcons(), onTimeSectionReplaced(form), reloadCurrentPopup(popup)
 */
export function initEditForm(form, callbacks = {}) {
  if (form.dataset.bound === 'true') {
    return;
  }

  form.dataset.bound = 'true';

  const elements = {
    errorsWrap: form.querySelector('.js-showing-view-edit-errors'),
    cancelButton: form.querySelector('.js-showing-view-edit-cancel'),
    listingSelect: form.querySelector('.js-showing-view-listing-select'),
    teamMemberSelect: form.querySelector('.js-showing-view-team-member-select'),
    showtimeTypeSelect: form.querySelector('.js-showing-view-showtime-type'),
    saveAsLeadLink: form.querySelector('.js-showing-view-save-as-lead'),
    clearShowtimeInput: form.querySelector('.js-showing-view-clear-showtime'),
    isLeadInput: form.querySelector('.js-showing-view-is-lead')
  };

  initEditTimeSection(form);

  const { resetSpecialFlags } = initEditFormActions(form, elements, callbacks);

  initEditFormSubmit(form, {
    ...callbacks,
    resetSpecialFlags
  });
}

export { reloadEditDependencies } from './edit_form_dependencies';
export { initEditTimeSection } from './edit_form_time_section';
